import { zonedTimeToUtc, toDate, utcToZonedTime, format } from 'date-fns-tz';

export const getUTCDateFromServerDate = (date) => zonedTimeToUtc(date, 'America/Los_Angeles');

export const getLocalDateFromServer = (date) => toDate(date, { timeZone: 'America/Los_Angeles' });

export const toDateSafe = (date) => (date ? new Date(date) : null);
export const toDateInputValue = (date) => (date ? date.toISOString().substr(0,10) : null);
export const toDateISOStr = (date) => (date ? date.toISOString() : null);
export const toUTCDateFromServer = (date) => (date ? getUTCDateFromServerDate(date) : null);
export const toFormattedDisplayDate = (date, formatStr = 'MM/dd/yyyy') => (date ? format(date, formatStr) : null);

export const isValidDate = (dateToCheck) => (dateToCheck && Object.prototype.toString.call(dateToCheck) === "[object Date]" && !isNaN(dateToCheck));

export const omitYearIfCurrent = (dateToFormat) => {
    if (dateToFormat.getFullYear() === new Date().getFullYear())
        return format(dateToFormat, 'MMM d');
    else
        return format(dateToFormat, 'MMM d, y');
}

//let unmodifiedDate = new Date(dateToFormat);
// let localZonedDate = getLocalDateFromServer(dateToFormat);
// const formatStr = 'yyyy-MM-dd HH:mm:ss';

// console.log('[Date Comparisons] date string: ', dateToFormat);
// console.log('[Date Comparisons] unmodified date (new Date()): ', unmodifiedDate);
// console.log('[Date Comparisons-Formatted] unmodified date: ', format(unmodifiedDate, formatStr));
// console.log('[Date Comparisons] zoned date (getUTCDateFromServerDate()): ', zonedDate);
// console.log('[Date Comparisons-Formatted] zoned date: ', format(zonedDate, formatStr));
// console.log('[Date Comparisons] local zoned date (getLocalDateFromServer()): ', localZonedDate);
// console.log('[Date Comparisons-Formatted] local zoned date: ', format(localZonedDate, formatStr));